import {regNavn} from "../../../../../felles/tjenester/tredjepartsTjenestenavn";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {EnumOversettelser} from "felles/tjenester/i18n/EnumOversettelser";
import {IPromise} from "angular";
import _, {isNumber} from "lodash";
import {GruppeRessurs} from "../../../../../felles/tjenester/ressurser/GruppeRessurs";
import {gettextCatalog} from "angular-gettext";
import {MeldingTilBruker} from "../../../../../felles/tjenester/MeldingTilBruker";

const debug: Debugger = require('debug')('AgendadokumentValgDialog');
require('./agendaDokumentValgDialog.scss');


export class AgendadokumentValgDialog implements MdDialogController {

    static visAgendadokumentValgDialog($mdDialog: angular.material.IDialogService, gruppeId: string): IPromise<void> {
        debug('visAgendadokumentValgDialog')
        return $mdDialog.show(this.dialogKonfigurasjon({gruppeId: gruppeId}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./agendaDokumentValgDialog.html'),
            controller: AgendadokumentValgDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            GruppeRessurs.regNavn,
            EnumOversettelser.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            AgendadokumentValgDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService,
                private gruppeRessurs: GruppeRessurs,
                private enumOversettelser: EnumOversettelser,
                private meldingtilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog
    ) {
    }

    gruppeId: string; // settes via locals
    modell: UtelattDel[];
    lagrer = false;

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit() {
        this.modell = _.toArray(l.AgendadokumentDel)
          .filter(isNumber)
          .map(dokumentDel => ({
              ikkeUtelatt: true,
              initielltIkkeUtelatt: true,
              enumVerdi: dokumentDel,
              navn: this.enumOversettelser.oversettAgendadokumentDel(dokumentDel)
          }));

        this.gruppeRessurs.hent(this.gruppeId).$promise
          .then(gruppe => {
              gruppe.oppsett.agendaDokumentValg.utelatteDeler
                .map(utelatt => this.modell.find(kandidat => kandidat.enumVerdi === utelatt))
                .forEach(modell => modell.ikkeUtelatt = modell.initielltIkkeUtelatt = false);
          });
    }

    lagre() {
        if (!this.modell.some(modell => modell.ikkeUtelatt != modell.initielltIkkeUtelatt)) {
            //ingen endringer
            this.$mdDialog.hide();
            return;
        }

        this.lagrer = true;

        const utelatteDeler = this.modell
          .filter(modell => !modell.ikkeUtelatt)
          .map(modell => modell.enumVerdi);

        this.gruppeRessurs.oppdaterAgendaDokumentValg(this.gruppeId, {utelatteDeler: utelatteDeler}).$promise
          .then(() => {
              this.$mdDialog.hide();
              this.meldingtilBruker.infomelding(this.gettextCatalog.getString("Agendadokument-oppsett er lagret!"));
          })
          .finally(this.lagrer = false)
    }
}

interface UtelattDel {
    enumVerdi: l.AgendadokumentDel;
    navn: string;
    ikkeUtelatt: boolean;
    initielltIkkeUtelatt: boolean;
}
